import { useGroups } from '@/composition'
import { useBuilderStore } from '@/store/builder'
import { computed, ref, watch } from 'vue'

const isOpen = ref(false)
let openDeferTimeoutId: number | undefined

export const usePropertiesDrawer = () => {
  const store = useBuilderStore()
  const activeGr = computed(() => store.activeGroup)
  const activeEl = computed(() => store.activeElement)
  const { selectoGroupTargets } = useGroups()
  const groupTargets = computed(() => selectoGroupTargets && selectoGroupTargets.value && selectoGroupTargets.value.length)

  /**
   * Defer opening to the next task so the pointer event that triggered the open
   * cannot be treated as a mask/outside click on the Naive UI drawer (same issue as modals).
   */
  const setOpen = () => {
    if (isOpen.value) return
    if (typeof window !== 'undefined') {
      if (openDeferTimeoutId != null) return
      openDeferTimeoutId = window.setTimeout(() => {
        openDeferTimeoutId = undefined
        isOpen.value = true
      }, 0)
    } else {
      isOpen.value = true
    }
  }
  const setClose = () => {
    if (typeof window !== 'undefined' && openDeferTimeoutId != null) {
      window.clearTimeout(openDeferTimeoutId)
      openDeferTimeoutId = undefined
    }
    isOpen.value = false
  }
  const toggleDrawer = () => {
    isOpen.value = !isOpen.value
  }
  watch([activeEl, activeGr, groupTargets], () => {
    if (activeEl.value || (activeGr.value && Object.keys(activeGr.value).length > 0) || groupTargets.value) {
      setOpen()
    } else {
      setClose()
    }
  })
  return {
    isOpen,
    setOpen,
    setClose,
    toggleDrawer,
  }
}
